import type {
  GetSpecByPatternIdRoute,
  GetSpecRoute,
} from '@knapsack/api-server/types';
import { ksHttpHeaders } from '@knapsack/core';
import { fetcher } from '@knapsack/utils';

export function createAppApiRestEndpointsClient({
  appApiUrl,
  siteId,
  token,
}: {
  appApiUrl: string;
  siteId: string;
  token: string;
}) {
  if (!appApiUrl) {
    throw new Error('appApiUrl is required');
  }
  try {
    const _url = new URL(appApiUrl);
  } catch (e) {
    throw new Error(`Invalid appApiUrl: '${appApiUrl}'`, { cause: e });
  }

  const headers: Record<string, string> = {
    [ksHttpHeaders.siteId]: siteId,
    Authorization: `Bearer ${token}`,
  };

  return {
    getSpec: async (body: GetSpecRoute['input']) => {
      return fetcher<GetSpecRoute['output']>({
        url: new URL(
          '/domains/patterns/inspect-spec' satisfies GetSpecRoute['path'],
          appApiUrl,
        ),
        headers,
        body: body satisfies GetSpecRoute['input'],
      });
    },
    getSpecByPatternId: async (body: GetSpecByPatternIdRoute['input']) => {
      return fetcher<GetSpecByPatternIdRoute['output']>({
        url: new URL(
          '/domains/patterns/inspect-spec-by-pattern-id' satisfies GetSpecByPatternIdRoute['path'],
          appApiUrl,
        ),
        headers,
        body: body satisfies GetSpecByPatternIdRoute['input'],
      });
    },
  };
}
